import React from "react";
import Education from "./Education";
import SkillsTools from "./Skills_Tools";

function Home(){
    return(
        <>
            <Education />
            <SkillsTools />
        </>
    );
}
export default Home;